module.exports = __webpack_public_path__ + "img/package.bb45bb5e.svg";